import { useMutation, useQueryClient } from '@tanstack/react-query'
import { pb } from '@/lib/pocketbase'
import { useAuth } from '@/context/auth-context'
import { queryKeys } from '@/lib/queries'

export const useShopPromo = () => {
  const { user } = useAuth()
  const queryClient = useQueryClient()

  // Determine if promo should show:
  // 1. User exists
  // 2. User has NOT seen the shop promo yet (false or null/undefined)
  // 3. User has shop access (true or null/undefined, NOT explicitly false)
  const shouldShowPromo = Boolean(
    user &&
    user.has_seen_shop_promo !== true &&
    user.access_shop !== false
  )

  // Mutation to mark promo as seen
  const dismissMutation = useMutation({
    mutationFn: async () => {
      if (!user?.id) throw new Error('No user')
      await pb.collection('users').update(user.id, { has_seen_shop_promo: true })
    },
    onSuccess: () => {
      // Invalidate user query to refetch updated data
      queryClient.invalidateQueries({ queryKey: queryKeys.user })
    },
  })

  const dismissPromo = () => {
    dismissMutation.mutate()
  }

  return {
    shouldShowPromo,
    dismissPromo,
    isLoading: dismissMutation.isPending,
  }
}
